// extracted by mini-css-extract-plugin
module.exports = {"dynasty":"style_dynasty__2cdqu","title":"style_title__3fg69","options":"style_options__2gp-V","list":"style_list__24CnY","listItem":"style_listItem__1fsAP"};